"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useViesValidate;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

var _splitVatNumber3 = _interopRequireDefault(require("./splitVatNumber"));

function useServiceCallViesValidate(options) {
  // const { clientCode, serviceNames } = useOrdersContext();
  var serviceName = (0, _useResolveServiceActionName.default)(null, 'v1.vies.validate'
  /* , serviceNames */
  );
  return (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, params) {
    return client.call(serviceName, params, {
      method: 'get'
    });
  });
}

function useViesValidate(_ref) {
  var useTest = _ref.useTest,
      viesInvoiceCountry = _ref.viesInvoiceCountry;
  var callService = useServiceCallViesValidate();
  return _react.default.useCallback( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(taxNo, pInvoiceCountry) {
      var invoiceCountry, _splitVatNumber, _splitVatNumber2, country, vatNumber;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // handle difference in ISO code and EU country code
              invoiceCountry = pInvoiceCountry === 'GR' ? 'EL' : pInvoiceCountry;
              _splitVatNumber = (0, _splitVatNumber3.default)(taxNo), _splitVatNumber2 = (0, _slicedToArray2.default)(_splitVatNumber, 2), country = _splitVatNumber2[0], vatNumber = _splitVatNumber2[1];

              if (!(invoiceCountry && invoiceCountry !== country || country === viesInvoiceCountry)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", false);

            case 4:
              return _context.abrupt("return", callService({
                country: country,
                vatNumber: vatNumber,
                useTest: useTest
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [callService, useTest, viesInvoiceCountry]);
}